import { render, staticRenderFns } from "./HomeView.vue?vue&type=template&id=2be245b3"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"
import style0 from "./HomeView.vue?vue&type=style&index=0&id=2be245b3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../dev/hemotrack-front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports